import { Container, Grid } from 'components/box';
import ProductListing from 'components/_shared/widgets/product-listing';
import { ProductListingProps } from 'components/_shared/widgets/product-listing/types';

const Body = (props: ProductListingProps) => (
  <Container py={3}>
    <Grid>
      <ProductListing {...props} />
    </Grid>
  </Container>
);

export default Body;
